export const enum AnalyticsEvent {
  //InitApplication
  InitApplication = 'InitApplication / User initialized the application',

  //Integrations
  OpenIntegrationsOverview = 'Integrations / Open Integrations Overview',

  //Report
  OpenReport = 'Report / Open report',

  //Demo 
  OpenDemo = 'Demo / Open demo',

  //PowerBI Embed events
  PBIEmbedEvent = 'PowerBIEmbedEvent / Power BI  embed event',

  //Scheduler events
  OpenSchedulerForm = 'Scheduler / Open scheduler form',
  SubmitSchedulerForm = 'Scheduler / Submit scheduler form',
  CancelSchedulerForm = 'Scheduler / Cancel scheduler form',
  SchedulerBlocked = 'Scheduler / Scheduler creation blocked',
  OpenLeadForm = 'Scheduler / Open lead form',
  SubmitLeadForm = 'Scheduler / Submit lead form',
  CancelLeadForm = 'Scheduler / Cancel lead form',
}
export type AnalyticsProperties = Record<string, unknown>
